import styled from "styled-components";
import { useAppSelector } from "../hooks";
import { auth, Utils } from "@tiffin/app-common";
import { Badge, Button, Popover } from "antd";
import { IonIcon } from "@ionic/react";
import { gridOutline, receiptOutline, cartOutline, chatboxOutline, personOutline } from 'ionicons/icons';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

export const MenuBar = styled(BaseMenuBar)`
  &.menu-bar {
    position: fixed;
    bottom: 0px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    width: 100%;
    background: #fff;
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.07);
    height: 70px;
    overflow-x: scroll;
    overflow-y: hidden;

    .menu-option {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      gap: 2px;
      padding: 12px 16px;
      color: var(--color-dark);
  
      ion-icon {
        font-size: 2em !important;
      }

      .menu-option-label {
        font-size: 0.875em;
        font-weight: 600;
      }
  
      &.selected {
        background: rgba(var(--app-base-color-rgb), 0.1);
        color: var(--app-base-color);
        font-weight: 600;
  
        ion-icon {
          color: var(--app-base-color);
        }
      }
    }
  }
`

interface IMenuBar {
  className?: string
}

function BaseMenuBar({className}: IMenuBar) {

  const authenticateStatus = useAppSelector((state) => state.authenticate.status)
  const partnerId = useAppSelector((state) => state.store.details?.id)
  const partnerUrlName = useAppSelector((state) => state.store.details?.urlName ? Utils.convertToLowerName(state.store.details?.urlName) : undefined)
  const cartItems = useAppSelector((state) => partnerId ? state.cartMulti.carts[partnerId]?.items : {});
  const conversationsMetrics = useAppSelector((state) => state.conversationsMetrics)

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  function numberofItems() {
    let totalCount = 0
    for (let date in cartItems) {
      let items = cartItems[date]
      for (let id in items) {
        totalCount += items[id].count
      }
    }
    return totalCount
  }

  const renderMenuItemIcon = (icon: string, badgeCount?: number) => <Badge count={badgeCount}><IonIcon icon={icon}/></Badge>

  function getSelectedKey() {
    if(location.pathname.startsWith(`/${partnerUrlName}/signin`)) {
      return 'signin'
    } else if(location.pathname.startsWith(`/${partnerUrlName}/account`)) {
      return 'account'
    } else if(location.pathname.startsWith(`/${partnerUrlName}/cart`) || location.pathname.startsWith(`/${partnerUrlName}/checkout`)) {
      return 'cart'
    } else if(location.pathname.startsWith(`/${partnerUrlName}/orders`)) {
      return 'orders'
    } else if(location.pathname.startsWith(`/${partnerUrlName}/messages`)) {
      return 'messages'
    } else if(location.pathname.startsWith(`/${partnerUrlName}`)) {
      return 'menu'
    }
    return ''
  }

  const handleSignOut = () => {
    if (auth.currentUser) {
      auth.signOut()
    }
    window.location.href = `/${partnerUrlName}${window.location.search}`
  }

  return (
    <div className={`menu-bar ${className}`}>
      <div className={`menu-option ${getSelectedKey() === "menu" ? "selected" : ""}`} onClick={() => navigate({pathname: `/${partnerUrlName}`, search: searchParams.toString()})}>
        {renderMenuItemIcon(gridOutline)}
        <span className="menu-option-label">Menu</span>
      </div>
      <div className={`menu-option ${getSelectedKey() === "cart" ? "selected" : ""}`} onClick={() => navigate({pathname: `/${partnerUrlName}/cart`, search: searchParams.toString()})}>
        {renderMenuItemIcon(cartOutline, numberofItems())}
        <span className="menu-option-label">Cart</span>
      </div>
      <div className={`menu-option ${getSelectedKey() === "orders" ? "selected" : ""}`} onClick={() => navigate({pathname: `/${partnerUrlName}/orders`, search: searchParams.toString()})}>
        {renderMenuItemIcon(receiptOutline)}
        <span className="menu-option-label">Orders</span>
      </div>
      <div className={`menu-option ${getSelectedKey() === "messages" ? "selected" : ""}`} onClick={() => navigate({pathname: `/${partnerUrlName}/messages`, search: searchParams.toString()})}>
        {renderMenuItemIcon(chatboxOutline, conversationsMetrics.metrics?.customerUnread)}
        <span className="menu-option-label">Messages</span>
      </div>
      <Popover
        content={
          <div style={{display: 'grid'}}>
            {
              authenticateStatus === "authenticated" ? 
              <>
                <Button style={{margin: '10px'}} type="link" onClick={() => navigate({pathname: `/${partnerUrlName}/account`, search: searchParams.toString()})}>Edit details</Button>
                <Button style={{margin: '10px'}} type="link" onClick={() => handleSignOut()}>Log out</Button>
              </>
              :
              <>
                <Button style={{margin: '10px'}} type="link" onClick={() => navigate({pathname: `/${partnerUrlName}/signin`, search: searchParams.toString()})}>Log In</Button>
              </>
            }
          </div>
        }
        trigger="click"
      >
        <div className={`menu-option ${getSelectedKey() === "account" ? "selected" : ""}`}>
          {renderMenuItemIcon(personOutline)}
          <span className="menu-option-label">Account</span>
        </div>
      </Popover>
    </div>
  )
}